import Vue from 'vue'
import Router from 'vue-router'
import MainPage from '@/components/page/MainPage'
import NearbyPage from '@/components/page/NearbyPage'
import AreaPage from '@/components/page/AreaPage'
import StationPage from '@/components/page/StationPage'
import DetailPage from '@/components/page/DetailPage'
import MyPage from '@/components/page/MyPage'
import LoginPage from '@/components/page/LoginPage'
import RegistPage from '@/components/page/RegistPage'
import FindPwPage from '@/components/page/FindPwPage'
import MystorePage from '@/components/page/MystorePage'
import SearchPage from '@/components/page/SearchPage'
import EditInfoPage from '@/components/page/EditInfoPage'
import EditPasswordPage from '@/components/page/EditPasswordPage'
import MaintenancePage from '@/components/page/MaintenancePage'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'MainPage',
      component: MainPage
    },
    {
      path: '/nearby',
      name: 'NearbyPage',
      component: NearbyPage
    },
    {
      path: '/area',
      name: 'AreaPage',
      component: AreaPage
    },
    {
      path: '/station',
      name: 'StationPage',
      component: StationPage
    },
    {
      path: '/detail',
      name: 'DetailPage',
      component: DetailPage
    },
    {
      path: '/mypage',
      name: 'MyPage',
      component: MyPage
    },
    {
      path: '/login',
      name: 'LoginPage',
      component: LoginPage
    },
    {
      path: '/regist',
      name: 'RegistPage',
      component: RegistPage
    },
    {
      path: '/findpw',
      name: 'FindPwPage',
      component: FindPwPage
    },
    {
      path: '/mystore',
      name: 'MystorePage',
      component: MystorePage
    },
    {
      path: '/search',
      name: 'SearchPage',
      component: SearchPage
    },
    {
      path: '/edit_info',
      name: 'EditInfoPage',
      component: EditInfoPage
    },
    {
      path: '/edit_password',
      name: 'EditPasswordPage',
      component: EditPasswordPage
    },
    // 임시 공지사항용 페이지 2025년 1월 22일 작업 이후 삭제해도 무방
    {
      path: '/maintence',
      name: 'MaintenancePage',
      component: MaintenancePage
    },

  ]
})

router.beforeEach((to,from,next) => {
  /*
  const start = new Date('2025-01-22T02:00:00');
  const end = new Date('2025-01-22T07:00:00');
  const now = new Date();

  if (now >= start && now <= end) {
    if (to.path !== '/maintence') {
      next('/maintence');
    } else {
      next();
    }
  } else {
    next();
  }
    */
  next();
})


export default router;


// WEBPACK FOOTER //
// ./src/router/index.js